module.exports = __webpack_public_path__ + "static/media/Doris M.44791395.png";